import React, { useState, useMemo, useRef } from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import menu from "../../assets/icons/dots in image viwer.svg";
import DropDownBox from "../custom/DropDownBox/DropDownBox";
import { useNavigate } from "react-router-dom";
import useOutsideClick from "../../hooks/useOutsideClick";
import { generateMenu } from "../../utils/MenuGenerator";

import NoImageUploader from "../global/NoImageUploader";
import { toast } from "react-toastify";
import {
  getImageDimensions,
  ImageSizeAndDimensionChecker,
  ImgIcon,
  toastMessage,
} from "../../utils/utils";
import deleteIcon from "../../assets/icons/DELETE __ DARK Red.svg";
import AddForIcon from "../../assets/icons/AddForIcon";
import ImageIcon from "./ImageIcon";
import LeftArrow from "../../assets/icons/LeftArrow";
import RightArrowIcon from "../../assets/icons/RightArrowIcon";

function cn(...inputs: any) {
  return twMerge(clsx(inputs));
}

const EditButton = ({ imageId, uploadApi, id, deleteApi, dimension }: any) => {
  const CarouselBox = [
    {
      name: "Add Image",
      tag: "AddImage",
      icon: AddForIcon,
      action: "test",
      color: "#1e1850",
    },
    {
      name: "Delete Image",
      tag: "deleteImage",
      icon: () => ImgIcon(deleteIcon, 28, 28),
      action: "deleteImage",
      color: "#eb0707",
    },
  ];

  const dropDownRef = useRef<HTMLButtonElement>(null);
  const [openDropDown, setOpenDropDown] = useState<boolean>(false);

  const closeDropDown = () => {
    setOpenDropDown(false);
  };

  const navigate = useNavigate();
  useOutsideClick(dropDownRef, closeDropDown);

  const deleteImageHandler = async () => {
    try {
      await toast.promise(
        deleteApi({ data: { image_id: imageId }, id: id }),
        toastMessage()
      );
    } catch (error) {}
  };

  const clubDropDown = generateMenu(
    CarouselBox,
    {
      test: {
        cb: () => {},
        isAsync: false,
        params: {},
      },
      deleteImage: {
        cb: deleteImageHandler,
        isAsync: false,
        params: {},
      },
    },
    {
      AddImage: {
        component: (item, onClick, closeDropDown) => {
          return (
            <>
              <input
                hidden
                accept={"image/*"}
                onChange={async (e) => {
                  //@ts-ignore
                  const file = e.target.files[0];
                  if (file) {
                    const { width, height } = await getImageDimensions(file);
                    if (
                      !ImageSizeAndDimensionChecker(
                        width,
                        height,
                        dimension[0],
                        dimension[0],
                        file.size
                      )
                    ) {
                      return;
                    }
                    const reader = new FileReader();
                    reader.onloadend = async () => {
                      const image = reader?.result
                        ?.toString()
                        .replace(/^data:image\/[a-zA-Z]+;base64,/, "");
                      await toast.promise(
                        uploadApi({ data: { image: image }, id: id }),
                        toastMessage()
                      );
                      //@ts-ignore
                    };
                    reader.readAsDataURL(file);
                  }
                  closeDropDown();
                }}
                type="file"
                id="uploadCarouselImage"
              />
              <label
                htmlFor="uploadCarouselImage"
                className="hover:bg-gray-100 w-full flex items-center justify-start rounded-md  py-2 px-2 gap-1"
              >
                {/* <img loading="lazy" src={addIcon} alt="" /> */}
                <AddForIcon />
                <p className="text-primary dark:text-white ">Add Image</p>
              </label>
            </>
          );
        },
      },
    }
  );
  return (
    <>
      <button
        //ref={dropDownRef}
        className="flex gap-2 items-center  p-2 rounded-md "
        onClick={() => setOpenDropDown((prev) => !prev)}
        type="button"
      >
        <img loading="lazy" src={menu} alt="" />
      </button>
      {/* @ts-ignore */}
      <div ref={dropDownRef}>
        {openDropDown && (
          <DropDownBox
            dropDownConfig={clubDropDown}
            title=""
            closeDropDown={closeDropDown}
            className=" absolute top-10 right-[20px]  w-[150px]  "
          />
        )}
      </div>
    </>
  );
};

const Carousel = ({
  images = [],
  uploadApi,
  deleteApi,
  clickHereRef,
  id,
  dimension,
}: {
  images: { id: number; image: string }[];
  uploadApi: any;
  deleteApi: any;
  clickHereRef: string;
  id: any;
  dimension: any;
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleDotsCount = 5; // Number of dots to display at a time

  const hasImages = useMemo(() => Boolean(images.length), [images]);

  const handleDotClick = (index: any) => {
    setCurrentIndex(index);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  // Determine the visible range of dots
  const startDot = Math.max(
    0,
    Math.min(
      currentIndex - Math.floor(visibleDotsCount / 2),
      images.length - visibleDotsCount
    )
  );
  const visibleDots = images.slice(startDot, startDot + visibleDotsCount);

  return (
    <div className="relative w-full h-[200px] flex flex-col hover:bg-white/10 duration-300 ease-in-out group overflow-hidden">
      {/* Dots Positioned Below the Image */}
      {hasImages && (
        <div className="gap-1.5 w-full p-0 px-4 pt-4 flex justify-center absolute bottom-5 z-10">
          {visibleDots.map((item, index) => {
            const actualIndex = startDot + index; // Map visible dot index to actual image index
            const isActive = currentIndex === actualIndex;

            return (
              <div
                key={item.id}
                onClick={() => handleDotClick(actualIndex)}
                className={cn(
                  "overflow-hidden relative shrink-0 h-2 bg-white bg-opacity-30 rounded-full cursor-pointer",
                  isActive ? "w-[30px]" : "w-2"
                )}
              >
                {isActive && (
                  <div className="absolute bottom-0 left-0 w-full h-2 bg-transparent rounded-full">
                    <div className="h-full bg-white rounded-full" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* Image Display */}

      <div className="relative w-full h-full">
        {!hasImages && (
          <NoImageUploader
            dimension={dimension}
            id={id}
            clickHereRef={clickHereRef}
            uploadApi={uploadApi}
          />
          // <>No images available...</>
        )}
        {hasImages &&
          images.map((item, index) => (
            <div
              key={item.id}
              className={cn(
                `flex flex-col w-full h-full absolute transition-opacity duration-1000 cursor-pointer`,
                index === currentIndex ? "opacity-100" : "opacity-0"
              )}
            >
              <div className=" absolute z-40 right-2 top-2">
                <EditButton
                  id={id}
                  deleteApi={deleteApi}
                  uploadApi={uploadApi}
                  imageId={item.id}
                  dimension={dimension}
                />
              </div>

              <div className="w-full h-[300px] group-hover:scale-110 transition-all duration-300 ease-in-out">
                <div
                  style={{
                    backgroundImage: `url('${item.image}')`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </div>
          ))}
      </div>

      {/* Arrows */}
      {hasImages && (
        <>
          {/* <img loading="lazy"
            className="absolute top-1/2 left-1 transform -translate-y-1/2 bg-white bg-opacity-50 hover:bg-opacity-80 rounded-full w-8 h-8 flex items-center justify-center focus:outline-none cursor-pointer"
            onClick={handlePrev}
            src={leftArrowIcon}
            alt="left-icon"
          /> */}

          <ImageIcon
            Icon={LeftArrow}
            onClick={handlePrev}
            className="absolute top-1/2 left-1 transform -translate-y-1/2 bg-white bg-opacity-50 hover:bg-opacity-80 rounded-full w-8 h-8 flex items-center justify-center focus:outline-none cursor-pointer"
            width={24}
            height={24}
          />

          <ImageIcon
            className="absolute top-1/2 right-1 transform -translate-y-1/2 bg-white bg-opacity-50 hover:bg-opacity-80 rounded-full w-8 h-8 flex items-center justify-center focus:outline-none cursor-pointer"
            onClick={handleNext}
            Icon={RightArrowIcon}
            width={24}
            height={24}
          />

          {/* <img loading="lazy"
            className="absolute top-1/2 right-1 transform -translate-y-1/2 bg-white bg-opacity-50 hover:bg-opacity-80 rounded-full w-8 h-8 flex items-center justify-center focus:outline-none cursor-pointer"
            onClick={handleNext}
            src={rightArrowIcon}
            alt="right-icon"
          /> */}
        </>
      )}
    </div>
  );
};

export default Carousel;
